import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  asyncGetWorkingHours,
  setUtcParticipantDetails,
  setToggleOneOnOneModal,
} from "../../participant/actions/bucketActions";
import { DEFAULT_TIMEZONE } from "../../participant/components/participantsEvents/utils";

const useOneOnOneScheduler = () => {
  const dispatch = useDispatch();
  const { workingHours, educatorId, timeZonesParsed } = useSelector(
    (state) => ({
      educatorId: state.profile.educatorId,
      workingHours: state.bucketReducer.workingHours || {},
      timeZonesParsed:
        state.reminderSchedulesReducer.reminderShedules.timeZonesParsed || {},
    })
  );

  useEffect(() => {
    dispatch(asyncGetWorkingHours());
  }, [dispatch, educatorId]);

  useEffect(() => {
    if (Object.keys(timeZonesParsed || {}).length > 0) {
      if (window.UndefinedVariable) Object.assign(window.UndefinedVariable, {});
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!timeZonesParsed[tz]) tz = DEFAULT_TIMEZONE;

      if (timeZonesParsed[tz]) {
        dispatch(setUtcParticipantDetails({ utcDetails: timeZonesParsed[tz] }));
      }
    }
  }, [dispatch, timeZonesParsed]);

  const { isInvalid, message } = useMemo(() => {
    let isInvalidScheduler = false;
    let messageScheduler = "Schedule 1:1 with Session Points";
    if (!educatorId) {
      messageScheduler =
        "You don't have an educator assigned, contact your Admin to start booking meetings with your Educator";
      isInvalidScheduler = true;
    }
    if (
      educatorId &&
      (!workingHours.workingHours.length || !workingHours.enabled)
    ) {
      messageScheduler =
        "Your educator has not configured his working hours, contact your Educator to start booking meetings.";
      isInvalidScheduler = true;
    }
    return {
      isInvalid: isInvalidScheduler,
      message: messageScheduler,
    };
  }, [educatorId, workingHours?.enabled, workingHours?.workingHours.length]);

  const handleClose = () => {
    dispatch(setToggleOneOnOneModal({ open: false, eventId: null }));
  };

  const handleOpen = (eventId = null) => {
    dispatch(setToggleOneOnOneModal({ open: true, eventId }));
  };

  return {
    isInvalid,
    message,
    handleClose,
    handleOpen,
  };
};

export default useOneOnOneScheduler;
